import axios from 'axios';

import actionTypes from './actionTypes';
import store from '../store/store';
import { API_CONFIG } from '../../config/api.config';

const convertFormToFormData = (state) => {
	const body = new FormData();

	Object.keys(state).forEach((key) => {
		body.append(key, state[key].value);
	});

	return body;
};

export const validateForm = () => (dispatch) => {
	const form = { ...store.getState().contact.userInfo, ...store.getState().contact.mail };
	let valid = true;

	for (const key in form) {
		if (form[key].required && !form[key].valid) {
			valid = false;
		}
	}

	dispatch({
		type: actionTypes.VALIDATE_FORM,
		valid,
	});
};

export const setMailInfo = ({
	familyName,
	name,
	tel,
	email,
	subject,
	file,
	message,
	rentDate,
	rentDescription,
}) => (dispatch) => {
	dispatch({
		type: actionTypes.SET_MAIL_INFO,
		userInfo: {
			familyName,
			name,
			tel,
			email,
		},
		mail: {
			subject,
			message,
			file,
			rentDate,
			rentDescription,
		},
	});

	dispatch(validateForm());
};

export const contactForProduct = product => (dispatch) => {
	const state = store.getState().contact;
	const type = state.mail.rentDate ? 'huren' : 'kopen';
	const subject = { value: `Geïntresseerd in het ${type} van ${product.name}`, valid: true };

	dispatch({
		type: actionTypes.CONTACT_FOR_PRODUCT,
		product,
		mail: {
			subject,
		},
	});
};
export const sendingFailed = () => (dispatch) => {
	dispatch({
		type: actionTypes.SENDING_FAILED,
	});
};
export const sendingSucceeded = () => (dispatch) => {
	dispatch({
		type: actionTypes.SENDING_SUCCEEDED,
	});
};
export const sendingInProgress = () => (dispatch) => {
	dispatch({
		type: actionTypes.SENDING_IN_PROGRESS,
	});
};
export const initMail = () => (dispatch) => {
	dispatch({
		type: actionTypes.INIT_MAIL,
	});
};
export const sendMail = () => (dispatch) => {
	const state = { ...store.getState().contact.userInfo, ...store.getState().contact.mail };
	const body = convertFormToFormData(state);

	sendingInProgress();

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.CONTACT}`, body)
		.then(() => {
			dispatch({
				type: actionTypes.SEND_MAIL,
			});
			dispatch(sendingSucceeded());
			dispatch(initMail());
		})
		.catch(() => dispatch(sendingFailed()));
};




// WEBPACK FOOTER //
// ./src/redux/contact/contactActions.js